// 表单验证方法

export default {
  // 检查姓名
  checkName (rule, value, callback) {
    if (value === '') {
      callback(new Error('姓名不能为空'))
    } else if (/\d/.test(value)) {
      callback(new Error('姓名不能包含数字'))
    } else {
      callback()
    }
  },
  // 验证电话
  checkPhone (rule, value, callback) {
    if (value === '') {
      callback(new Error('电话不能为空'))
    } else if (!(/^1[3456789]\d{9}$/.test(value))) {
      callback(new Error('请输入正确的手机号'))
    } else {
      callback()
    }
  },
  // 验证密码
  checkPassWord (rule, value, callback) {
    if (value === '') {
      callback(new Error('密码不能为空'))
    } else if (!(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/.test(value))) {
      callback(new Error('密码长度为6-16位，并且包含：字母 + 数字'))
    } else {
      callback()
    }
  },
  // 验证油枪
  validateGunNo (rule, value, callback) {
    if (value === '') {
      callback(new Error('油枪号不能为空'))
    } else if (!(/(^[1-9]\d*$)/.test(value))){
      callback(new Error('油枪号只能为正整数'))
    } else {
      callback()
    }
  },
  // 邮箱校验
  validateEmail (rule, value, callback) {
    const reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
    if(value === ''){
      callback(new Error('请输入邮箱'))
    }else if(!reg.test(value)){
      callback(new Error('请输入正确的邮箱'))
    }else{
      callback()
    }
  },
  // 纳税人识别号
  validateSellerTaxNo (rule, value, callback) {
    const reg = /^[0-9a-zA-Z]+$/
    if(value === ''){
      callback(new Error('请输入纳税人识别号'))
    }else if(!reg.test(value)){
      callback(new Error('请输入正确的格式'))
    }else{
      callback()
    }
  },
  // usf校验密码
  validetePassword (rule, value, callback) {
    const reg = /^[a-zA-Z0-9！@#-_]{8,20}$/

    // 校验连续字符
    function validateContinue (str) {
      for (let i = 0; i < str.length; i++) {
        let num = str[i].charCodeAt()
        let continueStr = str[i] + String.fromCharCode(num + 1) + String.fromCharCode(num + 2) + String.fromCharCode(num + 3)
        if (continueStr === (str[i] + str[i + 1] + str[i + 2] + str[i + 3])) return continueStr
      }
      return ''
    }

    if (/(.)\1\1\1/.test(value)) {
      callback(new Error('请勿连续出现4个及以上重复字符'))
    } else if (!reg.test(value)) {
      callback(new Error('请输入正确格式的密码'))
    } else {
      if ((/[a-z]/.test(value) + /[A-Z]/.test(value) + /[0-9]/.test(value) + /[_！@#-]/.test(value)) < 2) {
        callback(new Error('密码必须同时含有大小写字母、数字、特殊字符中的两种'))
      } else {
        let str = validateContinue(value)
        if (str) {
          callback(new Error(`存在连续字符${str}`))
        } else {
          callback()
        }
      }
    }  
  },
  // 身份证校验
  validateIdCard (rule, value, callback) {
    const reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
    if (!value) {
      callback(new Error('请输入身份证号'))
    } else if (!reg.test(value)) {
      callback(new Error('身份证格式错误'))
    } else {
      callback()
    }
  },
  // 统一社会信用代码校验
  checkSocialCreditCode (rule, value, callback) {
    var patrn = /^[0-9A-Z]+$/
    //18位校验及大写校验
    if (value.length !== 18 || patrn.test(value) == false) {
      callback(new Error('不是有效的统一社会信用代码！'))
    }
    var Ancode //统一社会信用代码的每一个值
    var Ancodevalue //统一社会信用代码每一个值的权重
    var total = 0
    var weightedfactors = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28] //加权因子
    var str = '0123456789ABCDEFGHJKLMNPQRTUWXY'
    //不用I、O、S、V、Z
    for (var i = 0; i < value.length - 1; i++) {
      Ancode = value.substring(i, i + 1)
      Ancodevalue = str.indexOf(Ancode)
      total = total + Ancodevalue * weightedfactors[i]
      //权重与加权因子相乘之和
    }
    var logiccheckcode = 31 - (total % 31)
    if (logiccheckcode === 31) {
      logiccheckcode = 0
    }
    var Str = '0,1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,T,U,W,X,Y'
    var Array_Str = Str.split(',')
    logiccheckcode = Array_Str[logiccheckcode]

    var checkcode = value.substring(17, 18)
    if (logiccheckcode != checkcode) {
      callback(new Error('不是有效的统一社会信用代码！'))
    }
    callback()
  }
}